<template>
  <section class="cta-section">
    <div class="overlay"></div>

    <div class="content">
      <h2>{{ $t("message.cta_title") }}</h2>

      <p>
        {{ $t("message.cta_description") }}
      </p>

      <div class="buttons">
        <button class="btn btn-outline" @click="showGuideModal = true">
          {{ $t("message.cta_joiin_guide") }}
        </button>

        <button class="btn btn-solid" @click="showTravelerModal = true">
          {{ $t("message.cta_join_traveler") }}
        </button>
      </div>
    </div>


    <!-- MODAL (outside hero) -->
    <GuideModal
      v-if="showGuideModal"
      @close="showGuideModal = false"
    />
    <TravelerModal
      v-if="showTravelerModal"
      @close="showTravelerModal = false"
    />

  </section>
</template>

<script>
import GuideModal from "./GuideModal.vue";
import TravelerModal from "./TravelerModal.vue";

export default {
  components: { 
    GuideModal,
    TravelerModal 
  },
  data() {
    return {
      showGuideModal: false,
      showTravelerModal: false
    };
  },
};
</script>

<style scoped>
.cta-section {
  position: relative;
  background-image: url("@/assets/images/Ready-to-start.png");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 150px;
  padding-bottom: 150px;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 60, 45, 0.75);
}

.content {
  position: relative;
  text-align: center;
  color: white;
  max-width: 720px;
  padding: 0 24px;
}

.content h2 {
  font-size: 42px;
  margin-bottom: 16px;
}

.content p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 32px;
  opacity: 0.95;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.btn {
  padding: 14px 28px;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  border: none;
}

.btn-outline {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.btn-solid {
  background: #ffffff;
  color: #0f3d3a !important;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .cta-section {
    height: auto;
    padding: 80px 0;
  }

  .content h2 {
    font-size: 32px;
  }

  .content p {
    font-size: 16px;
  }
}
</style>

